export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20273)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 3.375C20.7959 3.375 23.3272 4.50828 25.1595 6.34054C26.9917 8.17281 28.125 10.7041 28.125 13.5C28.125 16.2959 26.9917 18.8272 25.1595 20.6595C23.3272 22.4917 20.7959 23.625 18 23.625C15.2041 23.625 12.6728 22.4917 10.8405 20.6595C9.00828 18.8272 7.875 16.2959 7.875 13.5C7.875 10.7041 9.00828 8.17281 10.8405 6.34054C12.6728 4.50828 15.2041 3.375 18 3.375Z"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.6466 11.1084C18.3067 11.1084 18.9044 11.376 19.337 11.8086C19.7697 12.2412 20.0372 12.8389 20.0372 13.4991C20.0372 14.1593 19.7697 14.7569 19.337 15.1896C18.9044 15.6222 18.3067 15.8898 17.6466 15.8898C16.9864 15.8898 16.3887 15.6222 15.9561 15.1896C15.5234 14.7569 15.2559 14.1593 15.2559 13.4991C15.2559 12.8389 15.5234 12.2412 15.9561 11.8086C16.3887 11.376 16.9864 11.1084 17.6466 11.1084Z"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M18.4785 10.7556C19.1814 8.0527 19.9241 6.52442 20.5931 6.71287C21.5967 6.99554 23.1116 7.95944 22.9509 9.2159C22.8149 10.2794 21.5522 11.7904 20.0136 13.0716"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M19.7653 14.9461C22.1187 16.4498 23.3427 17.6285 22.9567 18.2065C22.3778 19.0736 20.9929 20.2165 19.8476 19.6754C18.8782 19.2174 17.8313 17.5495 17.0883 15.6904"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M14.9775 14.4102C12.3958 15.4755 10.7283 15.8021 10.4762 15.1543C10.098 14.1828 9.95611 12.3928 11.0563 11.765C11.9875 11.2336 13.9542 11.3327 15.9032 11.7904"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path d="M16.3124 23.0625L15.2402 28.8399" stroke="black" strokeWidth="1.5" />
                <path d="M19.6875 23.0625L20.7902 28.7837" stroke="black" strokeWidth="1.5" />
                <path d="M24.75 25.875V28.0139" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <rect x="7.5" y="28.875" width="21" height="3" rx="1.5" stroke="black" strokeWidth="1.5" />
            </g>
            <defs>
                <clipPath id="clip0_1975_20273">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
